import { takeEvery } from 'redux-saga/effects';

import * as homeActions from 'store/modules/home';
import { loadTopHosts } from './utils';

export default function* listenLoadTopHosts() {
  yield takeEvery(homeActions.loadTopHosts.toString(), loadTopHosts);
}
